import ReportView from './ReportView';

/**
 * Order report — one row per order, with the customer's custom fields
 * available as columns alongside the order totals and GST breakup.
 */
export default function OrderReportPage() {
  return (
    <ReportView
      title="Order report"
      subtitle="Every order in a range, with the columns you choose — totals, GST breakup and your own fields."
      endpoint="/reports/orders"
      storageKey="report.cols.orders"
      exportName="order-report"
      defaultColumns={['orderNo', 'orderDate', 'salesman', 'customer', 'status', 'taxable', 'cgst', 'sgst', 'igst', 'total']}
      statusOptions={[
        { value: 'pending', label: 'Pending' },
        { value: 'confirmed', label: 'Confirmed' },
        { value: 'dispatched', label: 'Dispatched' },
        { value: 'delivered', label: 'Delivered' },
        { value: 'cancelled', label: 'Cancelled' },
      ]}
    />
  );
}
